/** @format */

import React from 'react';
import { Form } from 'semantic-ui-react';

export default class CarInput extends React.Component {
  renderFormGroup() {
    const {
      name,
      value,
      options,
      onChange,
      isNew,
      chooseLabel,
      textName,
      textValue,
      editLabel,
      createLabel,
      textOnChange,
      active,
      forceSelect,
    } = this.props;

    const isEdit = value ? true : false;
    const isSelectActive =
      forceSelect || (!isNew && !textValue && options.length > 1);
    const isInputActive = !isSelectActive;

    return (
      <Form.Group>
        {this.renderActivateButton()}
        {active && isSelectActive && (
          <Form.Select
            label={chooseLabel}
            name={name}
            value={value}
            onChange={onChange}
            options={options}
            width="13"
          />
        )}
        {active && isInputActive && (
          <Form.Input
            label={isEdit ? editLabel : createLabel}
            name={textName}
            value={textValue}
            onChange={textOnChange}
            width="13"
          />
        )}
      </Form.Group>
    );
  }

  renderActivateButton() {
    const { active, buttonLabel, onButtonClick } = this.props;

    return (
      <Form.Button
        basic
        fluid={!active}
        width={active ? 3 : 16}
        icon={active ? '' : 'plus'}
        size="tiny"
        onClick={onButtonClick}
        content={active ? 'Annulla' : buttonLabel}
        label={active ? 'Annulla' : buttonLabel}
        className="sub-info-button"
      />
    );
  }

  render() {
    return this.renderFormGroup();
  }
}
